import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useGlobalState } from 'contexts/global-state'
import { useNavigate, useParams } from 'react-router-dom'
import { ApiService } from 'services/api'

import Add from './add'

export default function Edit() {
  const { id } = useParams<{ id: string }>()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const { openSuccessToast, openErrorToast } = useGlobalState()

  const { data } = useQuery<Affiliate>(
    QUERY_KEYS.AFFILIATES.EDIT(id as string),
    () => ApiService.Affiliates.get(id as string),
  )

  const updateAffiliate = useMutation({
    mutationFn: async ({
      id,
      affiliate,
    }: {
      id: string
      affiliate: AffiliatesApiRequest
    }) => {
      await ApiService.Affiliates.update({
        id,
        affiliate,
      })
    },
    onSuccess: (_data, { id, affiliate }) => {
      queryClient.setQueryData<AffiliatesApiRequest>(
        QUERY_KEYS.AFFILIATES.EDIT(id),
        (oldAffiliate) => {
          if (!oldAffiliate) return
          return affiliate
        },
      )

      openSuccessToast({
        message: `A afiliação ${affiliate.name} foi atualizada com sucesso!`,
      })

      navigate(ROUTES.AFFILIATES.LIST)
    },
    onError: (_error, { affiliate }) => {
      openErrorToast({
        message: `Erro ao editar ${affiliate.name}!`,
      })
    },
  })

  return (
    <Add
      affiliate={data}
      isEditMode
      onSave={async (affiliate: AffiliatesApiRequest) =>
        updateAffiliate.mutate({ id: id as string, affiliate })
      }
    />
  )
}
